export default "__VITE_ASSET__6d550659__"